import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const saveLeadResponse = (leadRespData) =>
  axios.post(`${baseUrl}/lead-response`, leadRespData);

export const saveUpcomingLeadInfo = (payload) =>
  axios.post(`${baseUrl}/upcoming-lead-info`, payload);

export const getUpcomingLeadById = ({ id, includeDeleted = false }) =>
  axios.get(`${baseUrl}/upcoming-lead-info/${id}`, {
    params: { includeDeleted }
  });

export const softDeleteUpcomingLeadInfo = (id) =>
  axios.delete(`${baseUrl}/upcoming-lead-info/${id}`);

export const fetchFunnelBySite = (paramsObj) =>
  axios.get(`${baseUrl}/funnel/site`, {
    params: paramsObj
  });

export const fetchSenderId = () =>
  axios.get(`${baseUrl}/funnel-insight/senderId`);

export const checkPostalCode = (funnelId, postalCode) =>
  axios.get(`${baseUrl}/funnel/site/check-postalcode`, {
    params: { funnelId, postalCode }
  });

export const recordBlockedPostalCode = (leadPayload) =>
  axios.post(`${baseUrl}/lead-response/record-blocked-postalcode`, leadPayload);

export const saveRecordAction = (payload) =>
  axios.post(`${baseUrl}/funnel-insight/recordAction`, payload);

export const recordWebsiteVisit = (payload) =>
  axios.post(`${baseUrl}/funnel-insight/website/record`, payload);

export const deleteQuestionVisit = (payload) =>
  axios.post(`${baseUrl}/funnel-insight/remove-insight`, payload);

export const saveLeadAddress = (id, { description, placeId, funnel }) =>
  axios.patch(`${baseUrl}/lead-response/save-address/${id}`, {
    description,
    placeId,
    funnel
  });

export const fetchAddressAutocompleteOptions = (queryText) =>
  axios.get(`${baseUrl}/address/autocomplete`, { params: { queryText } });
